import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/rem'

import Vant from 'vant'
import 'vant/lib/index.css';
import '@/assets/ConfigProvider.css'

import '@/assets/base.less'


const Vue = createApp(App)
Vue.use(Vant);

router.afterEach((to,from,next)=>{
  window.scrollTo(0,0)
})


Vue.use(store).use(router).mount('#app')


// LFV2A19K3C4016062

document.addEventListener('contextmenu', function(event) {
  event.preventDefault();
});
document.addEventListener('keydown', function(event) {
  if (event.key === 'F12') {
    // 阻止默认行为
    event.preventDefault();
  }
});